<template>
  <div class="r-center-header">
    <div class="r-center-address-box" :style="{width:width+'px'}">
      <div class="r-center-header common-flex common-justify-between common-align-center">
        <div class="common-flex">
            <div class="common-hover" @click="pushRouter(item)" :class="index!=list.length-1?'r-center-o-name':'r-center-t-name'" v-for="(item,index) in list" :key="index">
                {{item.name}} <span v-if="index!=list.length-1">></span>
            </div>
        </div>
        <slot name="search">
        </slot>
      </div>
      <slot name="bottom">
        </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "r-center-header",
  data() {
    return {};
  },
  props: {
    list: {
      type: Array,
      default: function () {
        return [
          {
            name: "Individual Account",
            to:'./user'
          },
          {
            name: "Customer Management",
          },
        ];
      },
    },
    width:{
      type:Number,
      default:1420
    }
  },
  methods:{
    pushRouter(e){
      if(e.to){
        this.$router.push(e.to)
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-center-header {
  .r-center-address-box {
    // width: 1420px;
    margin: 10px auto 0;
    background: #fff;
      border-bottom: 1px solid #f0f0f0;
    .r-center-header {
      height: 70px;
      padding: 26px 30px 25px;
      .r-center-o-name {
        opacity: 1;
        font-size: 16px;
        font-family: Roboto, Roboto-Regular;
        font-weight: 400;
        text-align: left;
        color: #000000;
        line-height: 19px;
      }
      .r-center-t-name {
        opacity: 1;
        font-size: 16px;
        font-family: Roboto, Roboto-Bold;
        font-weight: 700;
        text-align: left;
        color: #000000;
        line-height: 19px;
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-center-header.vue